import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ToastContainer, toast } from "react-toastify";
import RangeSlider from "react-range-slider-input";

import "../../node_modules/react-toastify/dist/ReactToastify.css";
import "react-range-slider-input/dist/style.css";
import Head from "next/head";
import axios from "axios";
import striptags from "striptags";
import Link from "next/link";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";
import Image from "next/image";
import proposal_img from "../../public/assets/images/proposal-img.png";
import file_upload_icon from "../../public/assets/images/file-upload-icon.png";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
const Layout = dynamic(() => import("../components/common/Layout/Layout"));
const Loader = dynamic(() => import("../components/common/Loader/Loader"));

const requestProposal = ({ apiData }) => {
  const router = useRouter();
  const sitekey = process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITEKEY;
  const reCaptchaRef = useRef(null);
  const [captchaError, setCaptchaError] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  const [minBudget, setMinBudget] = useState(500);
  const [maxBudget, setMaxBudget] = useState(150000);
  const [loader, setLoader] = useState(true);
  // const [footerData, setFooterData] = useState();

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const [fileError, setFileError] = React.useState("");
  const [contactData, setContactData] = useState();
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    const data = apiData;
    data && setContactData(data);
    if (footerData) {
      setLoader(false);
    }
  }, []);

  const valueLabelFormat = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleFileValidation = (file) => {
    const allowedExtensions = /(\.pdf|\.doc)$/i;
    const isFileValid = allowedExtensions.test(file.name);

    if (!isFileValid) {
      setFileError("Invalid file format. Please upload a PDF or DOC file.");
    } else {
      setFileError("");
    }
  };

  const handleSliderChange = (values) => {
    const increment = 500;
    const newMinBudget = Math.floor(values[0] / increment) * increment;
    const newMaxBudget = Math.ceil(values[1] / increment) * increment;

    setMinBudget(newMinBudget);
    setMaxBudget(newMaxBudget);
  };

  const renderError = (message) => <p className="help is-danger">{message}</p>;

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Please enter your name")
      .matches(
        /^[a-zA-Z\s]+$/,
        "Please enter a valid name with only alphabetical characters"
      )
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please enter your email")
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    phone_number: Yup.string()
      .required("Please enter your phone number")
      .matches(
        /^[0-9]+$/,
        "Please enter a valid phone number with only numeric characters"
      )
      .test(
        "len",
        "Maximum 10 characters are allowed",
        (val) => val && val.toString().length < 11
      ),
    country: Yup.string()
      .required("Please enter your country name")
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    project_description: Yup.string().required(
      "Please enter your Project Description"
    ),
    upload_file: Yup.mixed(),
    select_type_of_services_you_require: Yup.mixed().required(
      "Please select service type before submitting "
    ),
  });

  const initialValues = {
    name: "",
    email: "",
    phone_number: "",
    country: "",
    project_description: "",
    select_type_of_services_you_require: "",
  };

  const validateCAPTCHA = async (token) => {
    setCaptchaToken(token);
  };

  const validateCaptchaV3 = () => {
    return new Promise((resolve, reject) => {
      reCaptchaRef.current.executeAsync().then(async (value) => {
        resolve(value);
        // const captchaRes = await axios.post(`/api/validateCaptchaV3`, {
        //   token: value,
        // });
        // if (captchaRes.status === 200 && captchaRes.data.success) {
        // 	setCaptchaError('')
        //   resolve(true);
        // } else {
        // 	setCaptchaError('Invalid captcha.')
        //   reject(false);
        // }
      });
    });
  };

  const onSubmit = async (values, formikBag) => {
    try {
      // const isHuman = await validateCaptchaV3();
      const isHuman = true;

      if (isHuman) {
        const formData = new FormData();

        Object.entries(values).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData?.append("g-recaptcha-response", captchaToken);
        formData?.append("min_budget", minBudget);
        formData?.append("max_budget", maxBudget);
        axios
          .post(
            process.env.NEXT_PUBLIC_API_ENDPOINT +
            `/dynamic-form/${contactData?.form?.slug}/submissions/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            setCaptchaToken("");
            reCaptchaRef.current.reset();
            toast.success("Message Sent Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
            });
            setTimeout(() => {
              router.push("thank-you");
            }, 1500);
          })
          .catch(({ response }) => {
            setCaptchaToken("");
            reCaptchaRef.current.reset();
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
            });
          });

        formikBag.resetForm();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <main className="main-wrapper request-proposal-wrapper">
          <article className="wrapper-inner">
            <section className="proposal-section">
              <ToastContainer />
              <div className="proposal-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-7">
                      {contactData?.detail?.map((val, i) => {
                        // const titleWithoutPTag = striptags(
                        //   val?.value?.title,
                        //   "<span>"
                        // );
                        const titleWithoutPTag = val?.value?.title || "";
                        if (val?.type == "banner") {
                          return (
                            <div
                              className="heading request-proposal-heading"
                              key={i}
                            >
                              <span
                                itemProp="heading"
                                dangerouslySetInnerHTML={{
                                  __html: titleWithoutPTag,
                                }}
                              ></span>
                              <p
                                itemProp="description"
                                dangerouslySetInnerHTML={{
                                  __html: val?.value?.description,
                                }}
                              ></p>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                  <div className="proposal-form-wrapper">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {(formik) => (
                        <Form>
                          <div className="row custom-row">
                            <div className="col-lg-7">
                              <div className="row">
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {(val?.field_type == "singleline" ||
                                          val?.field_type == "email") && (
                                            <div className="col-md-6">
                                              <div className="input-wrapper">
                                                <div className="form-floating">
                                                  <Field
                                                    type="text"
                                                    className={`form-control ${formik.touched.clean_name &&
                                                        formik.errors.clean_name
                                                        ? "border-red-400"
                                                        : ""
                                                      }`}
                                                    placeholder={val?.label}
                                                    name={val?.clean_name}
                                                  />
                                                  <label className="form-label">
                                                    {val?.label}*
                                                  </label>
                                                </div>
                                                <ErrorMessage
                                                  name={val?.clean_name}
                                                  render={renderError}
                                                />
                                              </div>
                                            </div>
                                          )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.field_type == "multiline" && (
                                          <div className="col-lg-12">
                                            <div className="input-wrapper">
                                              <div className="form-floating ">
                                                <textarea
                                                  name={val?.clean_name}
                                                  className={`form-control textarea-floating ${formik.touched.val
                                                      ?.clean_name &&
                                                      formik.errors.val
                                                        ?.clean_name
                                                      ? "border-red-400"
                                                      : ""
                                                    }`}
                                                  placeholder={val?.label}
                                                  onChange={formik.handleChange(
                                                    val?.clean_name
                                                  )}
                                                ></textarea>
                                                <label className="form-label">
                                                  {val?.label}*
                                                </label>
                                              </div>
                                              <ErrorMessage
                                                name={val?.clean_name}
                                                render={renderError}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}

                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    if (val?.field_type === "multiselect") {
                                      const choicesArray = val?.choices
                                        .split(",")
                                        .map((choice) => choice.trim());

                                      return (
                                        <div className="col-lg-12" key={index}>
                                          <div className="input-wrapper">
                                            <div className="form-floating">
                                              <select
                                                className="form-select form-control"
                                                id="floatingSelect"
                                                aria-label={`Select ${val.label}`}
                                                name={val.clean_name}
                                                onChange={(e) =>
                                                  formik.handleChange(
                                                    val.clean_name
                                                  )(e)
                                                }
                                              >
                                                <option value="">
                                                  Select {val.label}
                                                </option>
                                                {choicesArray.map(
                                                  (choice, choiceIndex) => (
                                                    <option
                                                      key={choiceIndex}
                                                      value={choice}
                                                    >
                                                      {choice}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                              <label htmlFor="floatingSelect">
                                                {val.label}*
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name={val?.clean_name}
                                            render={renderError}
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  }
                                )}

                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.clean_name == "min_budget" && (
                                          <div className="col-md-6">
                                            <div className="input-wrapper">
                                              <div className="custom-range-wrapper">
                                                <span className="range-title">
                                                  Select your budget*
                                                </span>
                                                <div className="custom-range-input">
                                                  <RangeSlider
                                                    values={{
                                                      min: minBudget,
                                                      max: maxBudget,
                                                    }}
                                                    defaultValue={[500, 150000]}
                                                    onInput={(values) =>
                                                      handleSliderChange(values)
                                                    }
                                                    min={500}
                                                    max={500000}
                                                  />
                                                </div>
                                                <div className="range-input-value">
                                                  <span>
                                                    Min:
                                                    <span className="value">
                                                      ${valueLabelFormat(minBudget)}
                                                    </span>
                                                  </span>
                                                  <span>
                                                    Max:
                                                    <span className="value">
                                                      ${valueLabelFormat(maxBudget)}
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.field_type == "fileupload" && (
                                          <div className="col-md-6">
                                            <div className="input-wrapper">
                                              <div className="file-input">
                                                <input
                                                  type="file"
                                                  className="file-input-control"
                                                  id={val?.clean_name}
                                                  name={val?.clean_name}
                                                  onChange={(event) => {
                                                    formik.setFieldValue(
                                                      val?.clean_name,
                                                      event.currentTarget
                                                        .files[0]
                                                    );
                                                    handleFileValidation(
                                                      event.currentTarget
                                                        .files[0]
                                                    );
                                                  }}
                                                />
                                                <label
                                                  htmlFor={val?.clean_name}
                                                >
                                                  {formik.values[
                                                    val?.clean_name
                                                  ] ? (
                                                    formik.values[
                                                      val?.clean_name
                                                    ].name
                                                  ) : (
                                                    <>
                                                      <span className="input-title">
                                                        {val?.label}*
                                                      </span>
                                                    </>
                                                  )}
                                                  <span className="upload-container">
                                                    <span className="icon">
                                                      <Image
                                                        src={file_upload_icon}
                                                        alt="Upload"
                                                        height={100}
                                                        width={100}
                                                        loading="eager"
                                                      />
                                                    </span>
                                                    <span className="text">
                                                      Upload file pdf, doc,
                                                      world
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <p>
                                              {formik.errors[val?.clean_name] ||
                                                fileError}
                                            </p>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}

                                {captchaError && (
                                  <span className="captcha-error">
                                    {captchaError}
                                  </span>
                                )}
                                <ReCAPTCHA
                                  ref={reCaptchaRef}
                                  sitekey={sitekey}
                                  onChange={validateCAPTCHA}
                                />
                                <div className="col-12">
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    itemProp="link"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-5 col-md-5 col-7">
                              <div className="proposal-banner-img">
                                <Image
                                  height={500}
                                  width={500}
                                  src={proposal_img}
                                  alt="Request Precise Proposal"
                                  loading="eager"
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </section>
            <section className="case-studies-section">
              <div className="case-studies-inner">
                <div className="container">
                  {contactData?.detail?.map((val, index) => {
                    const titleWithoutPTag = striptags(val?.value?.heading);
                    return (
                      <React.Fragment key={`${index}_j`}>
                        {val?.type == "case_studies_block" && (
                          <>
                            <div className="row">
                              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="case-studies-title">
                                  <div className="section-heading">
                                    <h2
                                      itemProp="heading"
                                      dangerouslySetInnerHTML={{
                                        __html: titleWithoutPTag,
                                      }}
                                    ></h2>
                                  </div>
                                  {val.value?.case_studies_list_page_chooser?.map(
                                    (val, i) => {
                                      return (
                                        <div
                                          className="section-heading-right"
                                          key={i}
                                        >
                                          <Link
                                            href={val?.value?.page?.url}
                                            itemProp="link"
                                            className="link-font-lg"
                                          >
                                            {val?.value?.heading}
                                          </Link>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="div-grid-row">
                                  {val?.value?.case_studies?.map((val, i) => {
                                    return (
                                      <div key={i} className="div-grid-col">
                                        <div className="casestudies-card">
                                          {val?.value?.banner?.map(
                                            (val, ind) => {
                                              if (val?.type == "image") {
                                                return (
                                                  <div
                                                    key={`${ind}_n`}
                                                    className="casestudies-left"
                                                  >
                                                    <div className="casestudies-img">
                                                      <Link
                                                        href="#"
                                                        itemProp="link"
                                                      >
                                                        <Image
                                                          height={500}
                                                          width={500}
                                                          src={val?.value?.url}
                                                          alt={val?.value?.alt_text ?? 'digital-management-system'}
                                                          loading="eager"
                                                        />
                                                      </Link>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            }
                                          )}

                                          <div className="casestudies-right">
                                            <div className="casestudies-description">
                                              {val?.value?.banner?.map(
                                                (val, ind) => {
                                                  if (val?.type == "heading") {
                                                    return (
                                                      <h3
                                                        itemProp="heading"
                                                        key={`${ind}_k`}
                                                      >
                                                        <Link
                                                          href="#"
                                                          dangerouslySetInnerHTML={{
                                                            __html: val?.value,
                                                          }}
                                                        ></Link>
                                                      </h3>
                                                    );
                                                  }
                                                }
                                              )}
                                              {val?.value?.overview?.map(
                                                (val, ind) => {
                                                  if (val?.type == "project") {
                                                    return (
                                                      <div
                                                        key={`${ind}_k`}
                                                        className="casestudy-text"
                                                      >
                                                        <p>
                                                          {striptags(
                                                            val?.value
                                                              ?.description
                                                          )}
                                                        </p>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            </div>
                                            <div className="casestudies-button">
                                              <Link
                                                href={`/case-studies/${val?.value?.slug}`}
                                                itemProp="link"
                                              >
                                                <Image
                                                  width={25}
                                                  height={25}
                                                  src="../assets/images/right-arrow.svg"
                                                  alt="read-more"
                                                  loading="eager"
                                                />
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </section>
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/request-for-proposal-quote/",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  return {
    props: {
      apiData,
    },
  };
}

export default requestProposal;
